import {z} from 'zod'
import {ProjectId} from '../projects/ProjectId.js'
import {ConnectionId} from '../connection/ConnectionId.js'

export const GitHubRepository = z.object({
  connectionId: ConnectionId,
  id: z.number(),
  name: z.string(),
  projectId: ProjectId.nullish(),
  disabledTime: z.iso.datetime().nullish(),
})
export type GitHubRepository = z.infer<typeof GitHubRepository>
